export const BACKEND_URL = process.env.REACT_APP_API_BASE_URL;

export const ENDPOINTS = {
	// AUTHENTICATION
	OTP_VALIDATION: "/user/public/send-otp/",
	LOGIN: "/user/public/signin/",
	SIGNUP: "/user/public/signup/",
	RESEND_OTP: "/user/public/resend-otp/",
	UID_SIGNUP: "/user/public/uid-signup/",

	// Fingerprint AUTHENTICATION
	PASSKEY_REGISTER_INIT: "/user/passkey/register-init/",
	PASSKEY_REGISTER: "/user/passkey/register/",
	PASSKEY_LIST: "/user/passkey/",
	PASSKEY_SIGNIN_INIT: "/user/passkey/refresh-token/signin-init/",
	PASSKEY_SIGNIN: "/user/passkey/refresh-token/signin/",
	PASSKEY_ID_DELETE: `/user/passkey/`,

	// VALIDATE BIN NUMBER
	VALIDATION_BIN: (id) => `/bank/public/validate-bin/${id}`,

	// USER DETAIL
	FULL_USER_DETAIL: "/user/?details=full",
	USER_DETAIL: "/user/",

	// GLOBAL SEARCH
	GLOBAL_SEARCH: (id) => `/base/public/global-search/?${id}`,

	// GENERAL WEBSITE CONFIG
	GENERAL_WEBSITE_CONFIG : (config) => `/website/public/webpage-config/?${config}`,

	// REWARD LISTING 
	ADD_CARD: "/bank/card/",
	OFFER_CATEGORY: (id) => `/base/public/offer-categories/?${id}`,
	EVENT_LIST: (id) => `/base/public/events/?${id}`,
	BRAND_LIST: (id) => `/brand/public/list/?${id}`,
	COUNTRY_LIST: (id) => `/base/public/countries/?${id}`,
	BRAND_CATEGORY_LIST: (id) => `/base/public/brand-categories/?${id}`,
	SAVING_AMOUNT: "/base/saved-amount/",
	FILTER_SEARCH_RESULT: (id) => `/base/get-all-rewards/?${id}`,
	FILTER_PUBLIC_SEARCH_RESULT: (id) => `/base/public/get-rewards/?${id}`,
	FILTER_LIST: (id) => `/base/public/filter/?${id}`,
	HERO_OFFERS: (id) => `/base/hero-offers?${id}`,
	BUNDLE_LIST: (id) => `/bundle/list?${id}`,
	BUNDLE_DETAIL: (id, params) => `/bundle/${id}?${params}`,
	PURCHASE_BUNDLE: `/bundle/user/purchase/`,
	ORDER_BUNDLE_DETAIL: (id, params) => `/bundle/user/order/${id}?${params}`,

	//LANDING PAGE
	BANNER_URL: "/base/public/banners/?page_name=home",
	WHATSNEW_URL: (id) => `/base/public/new-rewards/?${id}`,
	POPULAR_CATEGORIES_URL: (id) => `/base/public/popular-categories/?${id}`,
	PUBLIC_REWARDS_URL: (id) => `/base/public/get-rewards?${id}`,
	FOOTER_STAT_URL: '/base/public/stats/',
	INTEGRATOR_INFO: (id) => `integrator/public/?${id}`,
	PRIVATE_SUBMODULE: (id) => `/bank/modules/?${id}`,
	PUBLIC_MODULE: (id) => `/bank/public/modules/?${id}`,
	SUPERCATEGORY: (id) => `/base/public/brand-super-categories/?${id}`,

	// REWARD DETAIL PAGE
	REWARD_DETAIL: (id) => `/base/get-reward-details/?${id}`,
	SIMILAR_RECOMMENDED_OFFER: (id) => `/base/get-similar-rewards/?${id}`,
	BANNER_DATA: (id) => `/base/public/banners/?${id}`,
	GET_CODE: (id) => `/brand/user/get-code/?${id}`,
	SAVE_PRIVATE_LEAD: (id) => `/brand/user/save-lead/?${id}`,
	GET_LINK: (id) => `/affiliate/user/get-link/?${id}`,
	GET_USER_LOCATION: (id) => `/brand/public/nearby-store/?${id}`,
	ADD_ASSIGN_REWARD: "/membership/user/assign/",
	ASSIGNED_OFFER_DETAIL: (id) => `/brand/user/get-assigned-code/?${id}`,
	// PAYMENT INTEGRATION DISCOUNT AND SUBSCRIPTION OFFERS
	GET_CODE_BY_PAYMENT: (id) => `/brand/user/get-code-by-payment/?${id}`,

	// PUBLIC REWARD DETAIL PAGE
	PUBIC_REWARD_DETAIL: (id) => `/base/public/reward-detail/?${id}`,
	PUBLIC_CODE: '/brand/public/get-offer/',
	INTEGRATOR_DETAIL: `integrator/public/`,

	// USER PROFILE PAGE
	PATCH_USER_UPDATE: "/user/update/",
	DELETE_CARD: (id) => `/bank/card/?${id}`,
	MAKE_DEFAULT_CARD: `/bank/card/make_default/`,
	SAVED_OFFER: (id) => `/base/user/saved-rewards?${id}`,
	ASSIGNED_OFFER: (id) => `/base/user/assigned-rewards?${id}`,
	LOYALTY_TIER: (id) => `/loyalty/user-stats?${id}`,
	USER_PROFILE_CONFIG: `/website/public/user-profile-page/`,
	USER_PROFILE_BUNDLE_INFO: (params) => `/bundle/user/orders?${params}`,
	// CONTACT US PAGE
	CREATE_CONTACT_US: "/base/public/form/",

	// PAYMENT INTEGRATION GIFTCARD
	PURCHASE_GIFTCARD: "/gift-card/user/v2/purchase-gift-card/",

	// GIFTCARD ORDER SUMMARY
	GIFTCARD_ORDER_SUMMARY: (id) => `/gift-card/user/order-details/?${id}`,

	// ORDER HISTORY
	GIFT_CARD_ORDER_HISTORY: (id) => `/gift-card/user/orders/?${id}`,
	CASHBACK_OFFER_ORDER_HISTORY: (id) => `/affiliate/user/orders/?${id}`,
	ASSIGNED_OFFER_ORDER_HISTORY: (id) => `/brand/user/assigned/?${id}`,

	// LOYALITY POINTS HISTORY
	LOYALITY_POINTS_HISTORY: (id) => `/loyalty/point-history?${id}`,

	// WEBSITE API LANDING PAGE
	WEBSITE_INFO: `/website/public/website/`,
	WEBSITE_LANDING_INFO: (id) => id ? `/website/public/home-page/?${id}` : `/website/public/home-page`,
	WEBSITE_HEADER_INFO: `/website/public/header/`,
	WEBSITE_REWARD_LISTING_INFO: (id) => id ? `/website/public/reward-listing/?${id}` : `/website/public/reward-listing`,
	WEBSITE_REWARD_DETAIL_INFO: (id) => id ? `/website/public/reward-detail/?${id}` : `/website/public/reward-detail`,

	// SHARE ON WHATSAPP
	SHARE_ON_WHATSAPP: "/base/send-reward-details/",

	// TRAVEL

	// FLIGHT
	GET_AIRPORT_SEARCH: (id) => `/flight/public/airport/?query=${id}`,
	FLIGHT_SEARCH: `/flight/public/search/`,
	FLIGHT_REPRICE: `/flight/reprice/`,
	FLIGHT_BOOKING: `/flight/book-ticket/`,
	FLIGHT_CALENDAR_FARE: `flight/public/calendar-fare/`,
	GET_PASSENGER: `/flight/user/passenger/`,
	SAVE_PASSENGER: `/flight/user/passenger/`,
	DELETE_PASSENGER: (id) => `/flight/user/passenger/?${id}`,
	SEAT_MAP: `/flight/seat-map/`,
	MEAL_BAGGAGE: `/flight/ssr/`,
	GET_GST_DETAIL: `/flight/user/gst/`,
	SAVE_GST_DETAIL: `/flight/user/gst/`,
	FLIGHT_DETAIL_CARDS: (id) => `/user/?details=${id}`,
	POPULAR_AIRPORT_LISTS: `/flight/public/popular-airports/`,
	FLIGHT_AI_REECOMMENDATION: `/flight/public/ai-recommendation/`,
	FLIGHT_BOOKING_HISTORY: (id) => `/flight/user/bookings/?${id}`,

	// HOTEL
	GET_HOTEL_CITY_SEARCH : (id) => `/hotel/public/place?query=${id}`,
	GET_POPULAR_DESTINATION: (limit = 10, page = 1) => `/hotel/public/popular-destinations?limit=${limit}&page=${page}`,
	HOTEL_SEARCH: `/hotel/public/search/`,
	HOTEL_INFO: (hotelId = '', engineId = 0) => `/hotel/hotel-details?hotel_id=${hotelId}&engine_id=${engineId}`,
	HOTEL_PREBOOKING: `/hotel/prebook/`,
	HOTEL_SIMILAR_PROPERTIES: `/hotel/similar-hotels/`,

	// PRECIOUS METALS
	// GET_PRECIOUS_METAL_DATA: (cardID = 1) => `/website/public/precious-metal-page/?card_id=${cardID}&page_name=PreciousMetalHome`,
	GET_PRECIOUS_METAL_DATA: (params) => `/website/public/precious-metal-page/?${params}`,
	GET_PINCODE_DETAILS: (pincode = 1) => `/precious-metals/pincode-details/?pincode=${pincode}`,
	VALIDATE_EXECUTE_REDEMPTION: '/precious-metals/validate-n-execute-redemption/',
	REDEMPTION_CATALOGUE: '/precious-metals/redemption-catalog/',
	GET_INVOICE: (orderId = '') => `/precious-metals/user/invoice/?order_id=${orderId}`,
	GET_ORDER_HISTORY: (param) => `/precious-metals/user/order-history/?${param}`,
	GET_PORTFOLIO: `/precious-metals/user/portfolio/`,
	VALIDATE_EXECUTE_QUOTE: `/precious-metals/validate-n-execute-quote/`,
	EXECUTE_SELL_QUOTE: `/precious-metals/execute-sell-quote/`,
	GET_QUOTE: (metal = '', operation = 'BUY', cardID = '') => 
		`/precious-metals/quote/?metal=${metal}&operation=${operation}&card_id=${cardID}`,
	ADDRESS: `/precious-metals/user/address/`,
	GET_METALS: `/precious-metals/public/metals`,
	GET_PROVIDERS: `/precious-metals/public/providers/`,
	GET_PRICE_HISTORY: (metals = 'GOLD,SILVER', timeframe = '1D') => 
		`/precious-metals/public/price-history/?metals=${metals}&timeframe=${timeframe}&currency=INR`,
	GET_METAL_PRICE: (currency = "INR", metal = "", operation = "") => `/precious-metals/public/get-price/?currency=${currency}&metals=${metal}&operation=${operation}`,
	GET_ORDER_DETAILS: (orderId = '') => `/precious-metals/user/order-details/?order_id=${orderId}`,
}
